/**
 * Illustration for error messages.
 *
 * This is exported from a JavaScript file instead of stored in a svg file in
 * the /images directory because we want it to be available offline. Error
 * messages will appear if a server fetch is unsuccessful, which is what
 * happens if a user loses their internet connection while using the product.
 * Therefore, it's very important that we can import this image instead of
 * inserting it via an image URL.
 */
import * as React from "react";

export default function BrainYarnError(): React.ReactElement {
    return (
        <svg viewBox="0 0 245 124" style={{width: 245, maxWidth: "100%"}}>
            <defs>
                <polygon
                    id="path-1"
                    points="0.51781 0.64956 62.973 0.64956 62.973 63.334 0.51781 63.334"
                />
                <path
                    id="path-3"
                    d="m1.58 0.66c-0.79 2.32-1.21 4.82-1.21 7.41 0.00 12.74 10.33 23.08 23.07 23.08 12.74 0 23.08-10.33 23.08-23.08 0-2.59-0.43-5.08-1.21-7.41l-43.72-0.00h-0.00z"
                />
                <path
                    id="path-5"
                    d="m2.21 0.66c-1.19 2.78-1.84 5.84-1.84 9.05 0.00 12.74 10.33 23.08 23.07 23.08 12.74-0.00 23.08-10.33 23.08-23.08 0-3.21-0.66-6.27-1.84-9.05l-42.46-0.00h0.00z"
                />
                <path
                    id="path-7"
                    d="m42.79 11.58c-4.12 6.32-11.24 10.50-19.35 10.50-12.14 0-22.09-9.37-23.00-21.28l42.35 0.00v10.78z"
                />
                <path
                    id="path-9"
                    d="m44.44 10.23c-3.64 7.96-11.67 13.50-21.00 13.50-12.69 0-22.99-10.25-23.07-22.92l44.08 0.00v9.42z"
                />
                <path
                    id="path-11"
                    d="m39.80 6.01c-4.23 5.27-10.72 8.65-18.01 8.65-9.58 0-17.80-5.84-21.29-14.15l39.29 0.00v5.50z"
                />
                <path
                    id="path-13"
                    d="m42.27 5.32c-4.06 6.59-11.35 10.99-19.66 10.99-10.2-0.00-18.85-6.62-21.90-15.79l41.56 0.00v4.81z"
                />
                <path
                    id="path-15"
                    d="m33.42 0.22c-4.20 4.33-10.07 7.02-16.57 7.02-6.50 0-12.38-2.69-16.57-7.02l33.15-0.00z"
                />
                <path
                    id="path-17"
                    d="m36.52 0.22c-4.23 5.28-10.73 8.67-18.02 8.67-7.29 0-13.80-3.38-18.02-8.67h36.05z"
                />
                <path
                    id="path-19"
                    d="m18.34 0.05c3.68 4.09 5.92 9.50 5.92 15.43 0 12.74-10.33 23.07-23.08 23.07-0.40 0-0.79-0.01-1.18-0.03l-0.00-38.48 18.34-0.00z"
                />
                <path
                    id="path-21"
                    d="m19.16 0.04c4.65 4.22 7.57 10.32 7.57 17.09 0 12.74-10.33 23.08-23.08 23.08-0.96 0-1.91-0.06-2.83-0.17l-0.00-40.00 18.34 0.00z"
                />
                <path
                    id="path-23"
                    d="m14.25 0.09c2.17 3.52 3.42 7.66 3.42 12.09 0 10.82-7.45 19.91-17.51 22.4l0.00-34.49 14.09 0.00z"
                />
                <path
                    id="path-25"
                    d="m14.77 0.08c2.85 3.84 4.54 8.6 4.54 13.75 0 11.41-8.28 20.89-19.16 22.75l-0.00-36.50 14.62-0.00z"
                />
                <path
                    id="path-27"
                    d="m9.35 0.14c1.11 2.70 1.72 5.66 1.72 8.75 0 8.22-4.29 15.43-10.76 19.52l0.00-28.27 9.04-0.00z"
                />
                <path
                    id="path-29"
                    d="m10.24 0.12c1.58 3.13 2.48 6.67 2.48 10.41 0 8.90-5.04 16.62-12.42 20.47l0.00-30.89 9.94-0.00z"
                />
                <path
                    id="path-31"
                    d="m0.41 1.01c1.32-0.24 2.68-0.36 4.07-0.36 12.74 0 23.08 10.33 23.08 23.08 0 2.32-0.34 4.56-0.98 6.67h-26.17l-0.00-29.39v0.00z"
                />
                <path
                    id="path-33"
                    d="m0.42 1.36c1.82-0.46 3.74-0.71 5.71-0.71 12.74 0 23.08 10.33 23.08 23.08-0.00 2.93-0.55 5.74-1.54 8.31h-27.24l0.00-30.68v0.00z"
                />
                <path
                    id="path-35"
                    d="m0.79 0.68c12.16 0.65 21.82 10.72 21.82 23.04 0 0.45-0.01 0.90-0.04 1.34h-21.79l-0.00-24.39v0.00z"
                />
                <path
                    id="path-37"
                    d="m0.79 0.65c0.13-0.00 0.26-0.00 0.40-0.00 12.74 0 23.08 10.33 23.08 23.08 0 1.01-0.07 2.00-0.19 2.98h-23.28l0.00-26.05v0.00z"
                />
                <path
                    id="path-39"
                    d="m0.34 0.78c8.30 2.46 14.65 9.47 16.16 18.15h-16.16l-0.00-18.15v-0.00z"
                />
                <path
                    id="path-41"
                    d="m0.34 0.35c9.64 2.10 17.03 10.21 18.03 20.22h-18.03l0.00-20.22v-0.00z"
                />
                <path
                    id="path-43"
                    d="m41.05 8.81c-4.23-4.99-10.55-8.16-17.61-8.16-12.74 0.00-23.07 10.33-23.07 23.08-0.00 3.12 0.62 6.10 1.74 8.81h38.94v-23.73 0.00z"
                />
                <path
                    id="path-45"
                    d="m42.70 11.02c-4.13-6.25-11.21-10.37-19.26-10.37-12.74 0.00-23.07 10.33-23.07 23.08-0.00 3.75 0.89 7.29 2.48 10.42h39.86v-23.13z"
                />
                <path
                    id="path-47"
                    d="m35.72 4.19c-3.56-2.24-7.77-3.54-12.29-3.54-12.74 0.00-23.07 10.33-23.07 23.08-0.00 1.19 0.09 2.35 0.26 3.49h35.10v-23.03 0.00z"
                />
                <path
                    id="path-49"
                    d="m37.33 5.30c-3.86-2.92-8.68-4.65-13.89-4.65-12.74 0.00-23.07 10.33-23.07 23.08-0.00 1.75 0.19 3.46 0.56 5.10h36.40v-23.53-0.00z"
                />
                <path
                    id="path-51"
                    d="m0.43 21.89c0.93-11.89 10.88-21.24 23.00-21.24 2.43 0.00 4.76 0.37 6.96 1.07v20.18h-29.96 0.00z"
                />
                <path
                    id="path-53"
                    d="m0.36 23.50c0.12-12.64 10.40-22.85 23.07-22.85 3.05 0.00 5.96 0.59 8.62 1.66v21.19h-31.69-0.00z"
                />
            </defs>
            <g id="Page-2" fillRule="evenodd" fill="none">
                <g id="LOHP-Copy-55" transform="translate(-559 -342)">
                    <g id="Page-1" transform="translate(559 342)">
                        <g id="Group-56">
                            <path
                                id="Fill-1"
                                fill="#12C3DB"
                                d="m213.99 102.49c-0.33 0-0.66-0.1-0.95-0.31l-96.2-68.93c-0.73-0.53-0.91-1.55-0.38-2.29 0.52-0.74 1.55-0.91 2.28-0.38l96.2 68.93c0.74 0.52 0.91 1.55 0.38 2.29-0.32 0.45-0.82 0.69-1.33 0.69"
                            />
                            <g id="Group-5" transform="translate(54.818)">
                                <mask id="mask-2" fill="white">
                                    <use xlinkHref="#path-1" />
                                </mask>
                                <path
                                    id="Fill-3"
                                    fill="#FF8482"
                                    mask="url(#mask-2)"
                                    d="m0.52 32.07c0.04 17.31 14.06 31.31 31.31 31.26 17.25-0.04 31.19-14.11 31.15-31.42s-14.06-31.31-31.31-31.26c-17.25 0.04-31.19 14.11-31.15 31.42"
                                />
                            </g>
                            <g id="Group-135" transform="translate(198 75)">
                                <g id="Group-59" transform="translate(0 15.66)">
                                    <mask id="mask-4" fill="white">
                                        <use xlinkHref="#path-3" />
                                    </mask>
                                    <path
                                        id="Fill-57"
                                        fill="#10ADCD"
                                        mask="url(#mask-4)"
                                        d="m-20.35 34.09c0-18.46 14.97-33.43 33.43-33.43 18.46-0.00 33.43 14.97 33.43 33.43"
                                    />
                                </g>
                                <g
                                    id="Group-62"
                                    transform="translate(0 14.011)"
                                >
                                    <mask id="mask-6" fill="white">
                                        <use xlinkHref="#path-5" />
                                    </mask>
                                    <path
                                        id="Fill-60"
                                        fill="#12C3DB"
                                        mask="url(#mask-6)"
                                        d="m46.51 37.39c-0.91 0-1.65-0.74-1.65-1.65 0-17.52-14.26-31.78-31.78-31.78-17.52 0.00-31.78 14.26-31.78 31.78 0 0.91-0.74 1.65-1.65 1.65s-1.65-0.74-1.65-1.65c0-19.34 15.74-35.08 35.08-35.08 19.34-0.00 35.08 15.74 35.08 35.08 0 0.91-0.74 1.65-1.65 1.65"
                                    />
                                </g>
                                <g
                                    id="Group-65"
                                    transform="translate(0 24.726)"
                                >
                                    <mask id="mask-8" fill="white">
                                        <use xlinkHref="#path-7" />
                                    </mask>
                                    <path
                                        id="Fill-63"
                                        fill="#10ADCD"
                                        mask="url(#mask-8)"
                                        d="m-21.79 21.92c2.75-14.62 19.34-23.77 37.07-20.43 17.72 3.33 29.86 17.88 27.12 32.50"
                                    />
                                </g>
                                <g
                                    id="Group-68"
                                    transform="translate(0 23.077)"
                                >
                                    <mask id="mask-10" fill="white">
                                        <use xlinkHref="#path-9" />
                                    </mask>
                                    <path
                                        id="Fill-66"
                                        fill="#12C3DB"
                                        mask="url(#mask-10)"
                                        d="m42.4 37.28c-0.10 0-0.20-0.01-0.31-0.03-0.89-0.17-1.48-1.03-1.31-1.92 1.24-6.58-0.73-13.37-5.53-19.12-4.88-5.85-12.08-9.91-20.27-11.46-16.80-3.16-32.57 5.42-35.14 19.12-0.17 0.89-1.03 1.48-1.92 1.31-0.90-0.17-1.48-1.03-1.32-1.92 2.91-15.49 20.40-25.25 38.99-21.75 8.95 1.68 16.83 6.15 22.20 12.58 5.44 6.53 7.66 14.28 6.24 21.84-0.15 0.79-0.84 1.34-1.62 1.34"
                                    />
                                </g>
                                <g
                                    id="Group-71"
                                    transform="translate(1.6484 32.143)"
                                >
                                    <mask id="mask-12" fill="white">
                                        <use xlinkHref="#path-11" />
                                    </mask>
                                    <path
                                        id="Fill-69"
                                        fill="#10ADCD"
                                        mask="url(#mask-12)"
                                        d="m-24.77 21.63c2.75-14.62 19.34-23.77 37.07-20.44 17.73 3.33 29.86 17.88 27.12 32.50"
                                    />
                                </g>
                                <g
                                    id="Group-74"
                                    transform="translate(.82419 30.495)"
                                >
                                    <mask id="mask-14" fill="white">
                                        <use xlinkHref="#path-13" />
                                    </mask>
                                    <path
                                        id="Fill-72"
                                        fill="#12C3DB"
                                        mask="url(#mask-14)"
                                        d="m40.23 36.99c-0.10 0-0.20-0.01-0.31-0.03-0.89-0.17-1.48-1.03-1.32-1.92 1.24-6.58-0.73-13.37-5.53-19.12-4.88-5.85-12.08-9.91-20.27-11.46-16.80-3.16-32.57 5.42-35.14 19.12-0.17 0.89-1.03 1.48-1.93 1.31-0.90-0.17-1.48-1.03-1.31-1.92 2.91-15.49 20.40-25.25 38.99-21.75 8.95 1.68 16.83 6.15 22.20 12.58 5.44 6.52 7.66 14.28 6.24 21.84-0.15 0.79-0.84 1.34-1.62 1.34"
                                    />
                                </g>
                                <g
                                    id="Group-77"
                                    transform="translate(6.5935 39.561)"
                                >
                                    <mask id="mask-16" fill="white">
                                        <use xlinkHref="#path-15" />
                                    </mask>
                                    <path
                                        id="Fill-75"
                                        fill="#10ADCD"
                                        mask="url(#mask-16)"
                                        d="m-31.06 21.34c2.75-14.62 19.34-23.77 37.07-20.44 17.72 3.33 29.86 17.89 27.12 32.50"
                                    />
                                </g>
                                <g
                                    id="Group-80"
                                    transform="translate(4.9451 37.913)"
                                >
                                    <mask id="mask-18" fill="white">
                                        <use xlinkHref="#path-17" />
                                    </mask>
                                    <path
                                        id="Fill-78"
                                        fill="#12C3DB"
                                        mask="url(#mask-18)"
                                        d="m34.77 36.70c-0.10 0-0.20-0.01-0.31-0.03-0.89-0.17-1.48-1.03-1.32-1.93 1.24-6.58-0.73-13.37-5.53-19.12-4.88-5.85-12.08-9.91-20.27-11.46-16.80-3.16-32.57 5.42-35.14 19.12-0.17 0.89-1.03 1.49-1.93 1.32-0.90-0.17-1.48-1.03-1.31-1.93 2.91-15.49 20.40-25.25 38.99-21.75 8.95 1.68 16.83 6.15 22.20 12.58 5.44 6.52 7.66 14.28 6.24 21.84-0.15 0.79-0.84 1.34-1.62 1.34"
                                    />
                                </g>
                                <g
                                    id="Group-83"
                                    transform="translate(22.253 8.2419)"
                                >
                                    <mask id="mask-20" fill="white">
                                        <use xlinkHref="#path-19" />
                                    </mask>
                                    <path
                                        id="Fill-81"
                                        fill="#10ADCD"
                                        mask="url(#mask-20)"
                                        d="m13.97 65.03c-13.84-6.85-18.12-26.41-9.56-43.7 8.55-17.29 26.71-25.75 40.54-18.90"
                                    />
                                </g>
                                <g
                                    id="Group-86"
                                    transform="translate(19.781 6.5935)"
                                >
                                    <mask id="mask-22" fill="white">
                                        <use xlinkHref="#path-21" />
                                    </mask>
                                    <path
                                        id="Fill-84"
                                        fill="#12C3DB"
                                        mask="url(#mask-22)"
                                        d="m16.45 68.32c-0.25 0-0.49-0.06-0.73-0.17-7.15-3.54-12.14-10.31-14.06-19.06-1.89-8.62-0.56-18.15 3.75-26.85 4.30-8.70 11.08-15.54 19.07-19.26 8.12-3.78 16.53-3.92 23.68-0.38 0.82 0.40 1.15 1.39 0.75 2.21-0.40 0.82-1.39 1.15-2.21 0.75-6.23-3.09-13.63-2.94-20.82 0.42-7.32 3.41-13.54 9.71-17.51 17.74-3.97 8.03-5.21 16.79-3.48 24.68 1.70 7.75 6.07 13.72 12.30 16.81 0.82 0.40 1.15 1.39 0.75 2.21-0.29 0.58-0.87 0.92-1.48 0.92"
                                    />
                                </g>
                                <g
                                    id="Group-89"
                                    transform="translate(28.847 11.539)"
                                >
                                    <mask id="mask-24" fill="white">
                                        <use xlinkHref="#path-23" />
                                    </mask>
                                    <path
                                        id="Fill-87"
                                        fill="#10ADCD"
                                        mask="url(#mask-24)"
                                        d="m14.13 65.07c-13.84-6.85-18.12-26.41-9.56-43.70 8.55-17.29 26.71-25.75 40.55-18.90"
                                    />
                                </g>
                                <g
                                    id="Group-92"
                                    transform="translate(27.198 9.8903)"
                                >
                                    <mask id="mask-26" fill="white">
                                        <use xlinkHref="#path-25" />
                                    </mask>
                                    <path
                                        id="Fill-90"
                                        fill="#12C3DB"
                                        mask="url(#mask-26)"
                                        d="m15.78 68.36c-0.24 0-0.49-0.06-0.73-0.17-7.15-3.54-12.14-10.31-14.06-19.06-1.89-8.62-0.56-18.15 3.75-26.85 4.30-8.70 11.08-15.54 19.07-19.26 8.12-3.79 16.53-3.92 23.68-0.38 0.82 0.40 1.15 1.39 0.74 2.21-0.40 0.82-1.39 1.15-2.21 0.75-6.24-3.09-13.63-2.94-20.83 0.42-7.32 3.41-13.54 9.71-17.51 17.74-3.97 8.03-5.21 16.79-3.48 24.68 1.70 7.75 6.07 13.72 12.3 16.81 0.82 0.40 1.15 1.39 0.75 2.21-0.29 0.58-0.87 0.92-1.48 0.92"
                                    />
                                </g>
                                <g
                                    id="Group-95"
                                    transform="translate(35.44 14.835)"
                                >
                                    <mask id="mask-28" fill="white">
                                        <use xlinkHref="#path-27" />
                                    </mask>
                                    <path
                                        id="Fill-93"
                                        fill="#10ADCD"
                                        mask="url(#mask-28)"
                                        d="m14.28 65.11c-13.84-6.85-18.12-26.41-9.56-43.70 8.55-17.29 26.71-25.75 40.54-18.90"
                                    />
                                </g>
                                <g
                                    id="Group-98"
                                    transform="translate(33.792 13.187)"
                                >
                                    <mask id="mask-30" fill="white">
                                        <use xlinkHref="#path-29" />
                                    </mask>
                                    <path
                                        id="Fill-96"
                                        fill="#12C3DB"
                                        mask="url(#mask-30)"
                                        d="m15.93 68.41c-0.25 0-0.49-0.06-0.73-0.17-7.15-3.54-12.14-10.31-14.06-19.06-1.89-8.62-0.56-18.15 3.75-26.85 4.30-8.70 11.08-15.54 19.07-19.26 8.12-3.79 16.53-3.92 23.68-0.38 0.82 0.40 1.15 1.39 0.75 2.21-0.40 0.82-1.39 1.15-2.21 0.75-6.23-3.09-13.63-2.94-20.82 0.42-7.32 3.41-13.54 9.71-17.51 17.74-3.97 8.03-5.21 16.79-3.48 24.68 1.70 7.75 6.07 13.72 12.3 16.81 0.82 0.40 1.15 1.39 0.75 2.21-0.29 0.58-0.87 0.92-1.48 0.92"
                                    />
                                </g>
                                <g id="Group-101" transform="translate(18.956)">
                                    <mask id="mask-32" fill="white">
                                        <use xlinkHref="#path-31" />
                                    </mask>
                                    <path
                                        id="Fill-99"
                                        fill="#10ADCD"
                                        mask="url(#mask-32)"
                                        d="m48.13 22.21c-10.92 10.92-28.62 10.92-39.53 0-10.92-10.92-10.92-28.62-0.00-39.53"
                                    />
                                </g>
                                <g id="Group-104" transform="translate(17.308)">
                                    <mask id="mask-34" fill="white">
                                        <use xlinkHref="#path-33" />
                                    </mask>
                                    <path
                                        id="Fill-102"
                                        fill="#12C3DB"
                                        mask="url(#mask-34)"
                                        d="m30.01 32.04c-7.91 0-15.34-3.08-20.93-8.67-11.54-11.54-11.54-30.32-0.00-41.87 0.64-0.64 1.69-0.64 2.33 0 0.64 0.64 0.64 1.69 0 2.33-10.26 10.26-10.26 26.95 0 37.20 4.97 4.97 11.57 7.71 18.60 7.71s13.63-2.74 18.60-7.71c0.64-0.64 1.69-0.64 2.33 0s0.64 1.69 0 2.33c-5.59 5.59-13.03 8.67-20.93 8.67"
                                    />
                                </g>
                                <g id="Group-107" transform="translate(23.901)">
                                    <mask id="mask-36" fill="white">
                                        <use xlinkHref="#path-35" />
                                    </mask>
                                    <path
                                        id="Fill-105"
                                        fill="#10ADCD"
                                        mask="url(#mask-36)"
                                        d="m48.51 16.88c-10.92 10.92-28.62 10.92-39.53 0-10.92-10.92-10.92-28.62-0.00-39.53"
                                    />
                                </g>
                                <g id="Group-110" transform="translate(22.253)">
                                    <mask id="mask-38" fill="white">
                                        <use xlinkHref="#path-37" />
                                    </mask>
                                    <path
                                        id="Fill-108"
                                        fill="#12C3DB"
                                        mask="url(#mask-38)"
                                        d="m30.39 26.70c-7.58 0-15.16-2.89-20.93-8.66-5.59-5.59-8.67-13.03-8.67-20.93-0.00-7.91 3.08-15.34 8.67-20.93 0.64-0.64 1.69-0.64 2.33 0 0.64 0.64 0.64 1.69 0 2.33-4.97 4.97-7.70 11.57-7.70 18.60 0 7.03 2.74 13.63 7.70 18.60 10.26 10.26 26.95 10.26 37.20 0 0.64-0.64 1.69-0.64 2.33 0 0.64 0.64 0.64 1.69 0 2.33-5.77 5.77-13.35 8.66-20.93 8.66"
                                    />
                                </g>
                                <g
                                    id="Group-113"
                                    transform="translate(29.671 .82419)"
                                >
                                    <mask id="mask-40" fill="white">
                                        <use xlinkHref="#path-39" />
                                    </mask>
                                    <path
                                        id="Fill-111"
                                        fill="#10ADCD"
                                        mask="url(#mask-40)"
                                        d="m48.06 10.73c-10.92 10.92-28.62 10.92-39.53 0-10.92-10.92-10.92-28.62-0.00-39.53"
                                    />
                                </g>
                                <g
                                    id="Group-116"
                                    transform="translate(28.022 .82419)"
                                >
                                    <mask id="mask-42" fill="white">
                                        <use xlinkHref="#path-41" />
                                    </mask>
                                    <path
                                        id="Fill-114"
                                        fill="#12C3DB"
                                        mask="url(#mask-42)"
                                        d="m29.94 20.57c-7.91 0-15.34-3.08-20.93-8.67-5.59-5.59-8.67-13.03-8.67-20.93 0.00-7.91 3.08-15.34 8.67-20.93 0.64-0.64 1.69-0.64 2.33 0 0.64 0.64 0.64 1.69 0 2.33-4.97 4.97-7.70 11.57-7.70 18.60 0 7.03 2.74 13.63 7.70 18.60 4.97 4.97 11.57 7.71 18.60 7.71s13.63-2.74 18.60-7.71c0.64-0.64 1.69-0.64 2.33 0 0.64 0.64 0.64 1.69 0 2.33-5.59 5.59-13.03 8.67-20.93 8.67"
                                    />
                                </g>
                                <g id="Group-119">
                                    <mask id="mask-44" fill="white">
                                        <use xlinkHref="#path-43" />
                                    </mask>
                                    <path
                                        id="Fill-117"
                                        fill="#10ADCD"
                                        mask="url(#mask-44)"
                                        d="m34.88-30.87c10.92 10.92 6.95 32.58-8.86 48.39-15.81 15.81-37.47 19.77-48.39 8.86"
                                    />
                                </g>
                                <g id="Group-122">
                                    <mask id="mask-46" fill="white">
                                        <use xlinkHref="#path-45" />
                                    </mask>
                                    <path
                                        id="Fill-120"
                                        fill="#12C3DB"
                                        mask="url(#mask-46)"
                                        d="m-6.12 34.15c-6.80 0.00-12.94-2.14-17.41-6.61-0.64-0.64-0.64-1.69 0-2.33 0.64-0.64 1.69-0.64 2.33 0 10.26 10.26 30.92 6.28 46.06-8.86 7.41-7.41 12.38-16.35 13.99-25.16 1.57-8.59-0.25-16.01-5.14-20.90-0.64-0.64-0.64-1.69 0-2.33 0.64-0.64 1.69-0.64 2.33 0 5.67 5.67 7.82 14.13 6.05 23.82-1.73 9.47-7.03 19.02-14.90 26.90-10.07 10.07-22.53 15.46-33.31 15.46"
                                    />
                                </g>
                                <g id="Group-125">
                                    <mask id="mask-48" fill="white">
                                        <use xlinkHref="#path-47" />
                                    </mask>
                                    <path
                                        id="Fill-123"
                                        fill="#10ADCD"
                                        mask="url(#mask-48)"
                                        d="m29.56-36.19c10.92 10.92 6.95 32.58-8.86 48.39-15.81 15.81-37.47 19.77-48.39 8.86"
                                    />
                                </g>
                                <g id="Group-128">
                                    <mask id="mask-50" fill="white">
                                        <use xlinkHref="#path-49" />
                                    </mask>
                                    <path
                                        id="Fill-126"
                                        fill="#12C3DB"
                                        mask="url(#mask-50)"
                                        d="m-11.45 28.83c-6.80 0-12.94-2.14-17.41-6.61-0.64-0.64-0.64-1.69 0-2.33 0.64-0.64 1.69-0.64 2.33 0 10.26 10.26 30.92 6.29 46.06-8.86 15.14-15.14 19.11-35.80 8.86-46.06-0.64-0.64-0.64-1.69 0-2.33 0.64-0.64 1.69-0.64 2.33 0 11.54 11.54 7.57 34.30-8.86 50.72-10.07 10.07-22.53 15.46-33.31 15.46"
                                    />
                                </g>
                                <g id="Group-131">
                                    <mask id="mask-52" fill="white">
                                        <use xlinkHref="#path-51" />
                                    </mask>
                                    <path
                                        id="Fill-129"
                                        fill="#10ADCD"
                                        mask="url(#mask-52)"
                                        d="m24.23-41.52c10.92 10.92 6.95 32.58-8.86 48.39-15.81 15.81-37.47 19.77-48.39 8.86"
                                    />
                                </g>
                                <g id="Group-134">
                                    <mask id="mask-54" fill="white">
                                        <use xlinkHref="#path-53" />
                                    </mask>
                                    <path
                                        id="Fill-132"
                                        fill="#12C3DB"
                                        mask="url(#mask-54)"
                                        d="m-16.77 23.50c-6.80 0-12.94-2.14-17.41-6.61-0.64-0.64-0.64-1.69 0-2.33 0.64-0.64 1.69-0.64 2.33 0 10.26 10.26 30.92 6.29 46.06-8.85 7.41-7.41 12.38-16.35 13.99-25.16 1.57-8.59-0.25-16.01-5.14-20.90-0.64-0.64-0.64-1.69 0-2.33 0.64-0.64 1.69-0.65 2.33 0 5.67 5.67 7.82 14.13 6.05 23.82-1.73 9.46-7.03 19.02-14.90 26.90-10.07 10.07-22.53 15.46-33.31 15.46"
                                    />
                                </g>
                            </g>
                            <path
                                id="Fill-6"
                                fill="#FF8482"
                                d="m20.37 52.34c0.04 17.31 14.06 31.31 31.31 31.26 17.25-0.04 31.19-14.11 31.15-31.42-0.04-17.31-14.06-31.31-31.31-31.26s-31.19 14.11-31.15 31.42"
                            />
                            <path
                                id="Fill-8"
                                fill="#FF8482"
                                d="m4.22 77.11c0.04 17.31 14.06 31.31 31.31 31.27 17.25-0.05 31.19-14.12 31.15-31.43-0.04-17.31-14.06-31.31-31.31-31.26-17.25 0.04-31.19 14.11-31.15 31.42"
                            />
                            <path
                                id="Fill-10"
                                fill="#FF8482"
                                d="m27.60 90.72c0.04 17.31 14.06 31.31 31.31 31.26 17.25-0.04 31.19-14.11 31.15-31.42-0.04-17.31-14.06-31.31-31.31-31.26-17.25 0.04-31.19 14.11-31.15 31.42"
                            />
                            <path
                                id="Fill-12"
                                fill="#FF8482"
                                d="m61.96 88.03c0.04 17.31 14.06 31.31 31.31 31.26 17.25-0.04 31.19-14.11 31.15-31.42-0.05-17.31-14.06-31.31-31.31-31.26-17.25 0.04-31.19 14.11-31.15 31.42"
                            />
                            <path
                                id="Fill-14"
                                fill="#FF8482"
                                d="m95.03 87.95c0.04 17.31 14.06 31.30 31.30 31.26 17.25-0.04 31.19-14.11 31.15-31.42-0.04-17.31-14.06-31.31-31.31-31.26-17.24 0.04-31.19 14.11-31.14 31.42"
                            />
                            <path
                                id="Fill-16"
                                fill="#FF8482"
                                d="m89.74 45.65c0.04 17.31 14.06 31.31 31.31 31.26 17.24-0.04 31.19-14.11 31.15-31.42-0.05-17.31-14.06-31.31-31.31-31.26-17.25 0.04-31.19 14.11-31.15 31.42"
                            />
                            <path
                                id="Fill-18"
                                fill="#FF8482"
                                d="m115.43 69.76c0.04 17.31 14.06 31.31 31.31 31.27 17.24-0.05 31.19-14.12 31.14-31.43-0.04-17.31-14.06-31.31-31.3-31.26-17.25 0.04-31.19 14.11-31.15 31.42"
                            />
                            <path
                                id="Fill-20"
                                fill="#F9685D"
                                d="m51.59 83.95c-8.63 0-16.76-3.36-22.88-9.48-6.14-6.13-9.54-14.30-9.56-23.00-0.00-0.67 0.54-1.22 1.21-1.22h0.00c0.67 0 1.21 0.54 1.22 1.22 0.02 8.05 3.16 15.60 8.85 21.28 5.66 5.66 13.18 8.77 21.16 8.77 0.03 0 0.06 0.00 0.08-0.00 0.67 0 1.21 0.55 1.22 1.22 0.00 0.67-0.54 1.22-1.21 1.22h-0.09z"
                            />
                            <path
                                id="Fill-22"
                                fill="#F9685D"
                                d="m108.24 114.91c-0.25 0-0.51-0.08-0.73-0.24-8.12-6.2-12.79-15.63-12.82-25.85-0.00-0.67 0.54-1.22 1.21-1.22 0.69-0.04 1.22 0.54 1.22 1.22 0.03 9.46 4.35 18.18 11.86 23.91 0.53 0.41 0.64 1.18 0.23 1.71-0.24 0.32-0.6 0.48-0.97 0.48"
                            />
                            <path
                                id="Fill-24"
                                fill="#F9685D"
                                d="m90.61 46.87c-0.67 0-1.21-0.55-1.22-1.22-0.00-0.46 0.01-0.92 0.03-1.37 0.51-13.25 9.24-25.09 21.72-29.46 0.63-0.22 1.33 0.11 1.55 0.75 0.22 0.64-0.12 1.33-0.75 1.55-11.54 4.04-19.62 15.00-20.09 27.25-0.02 0.42-0.02 0.84-0.02 1.27 0.00 0.67-0.54 1.22-1.21 1.22h-0.00z"
                            />
                            <path
                                id="Fill-26"
                                fill="#F9685D"
                                d="m146.66 102.25c-7.72 0-15.19-2.77-21.06-7.79-0.51-0.44-0.57-1.21-0.13-1.72 0.43-0.51 1.2-0.57 1.71-0.14 5.42 4.65 12.34 7.20 19.48 7.20 0.02 0 0.05-0.00 0.07-0.00 2.49-0.01 4.96-0.32 7.35-0.93 0.65-0.17 1.31 0.23 1.48 0.88 0.16 0.65-0.23 1.32-0.88 1.48-2.58 0.66-5.25 1-7.94 1.01h-0.08z"
                            />
                            <path
                                id="Fill-28"
                                fill="#F9685D"
                                d="m78.80 115.27c-0.32 0-0.64-0.12-0.87-0.37-0.47-0.48-0.45-1.26 0.03-1.72 4.17-4.05 7.06-9.16 8.37-14.80 0.15-0.66 0.81-1.06 1.46-0.91 0.65 0.15 1.06 0.81 0.91 1.46-1.41 6.09-4.54 11.62-9.05 15.99-0.23 0.23-0.54 0.34-0.84 0.34"
                            />
                            <path
                                id="Fill-30"
                                fill="#F9685D"
                                d="m103.98 89.81c-3.99 0-7.99-0.75-11.84-2.26-0.63-0.24-0.93-0.95-0.69-1.58 0.24-0.63 0.95-0.94 1.57-0.69 7.67 3.01 16.02 2.76 23.5-0.70 0.61-0.28 1.33-0.01 1.61 0.60s0.01 1.34-0.6 1.62c-4.33 2.01-8.94 3.01-13.56 3.01"
                            />
                            <path
                                id="Fill-32"
                                fill="#F9685D"
                                d="m76.96 35.20c-0.38 0-0.75-0.18-0.99-0.51-4.45-6.21-10.98-10.45-18.41-11.96-1.98-0.4-4.01-0.61-6.05-0.60h-0.00c-0.67 0-1.21-0.54-1.22-1.22-0.00-0.67 0.54-1.22 1.21-1.22 2.19 0.01 4.40 0.21 6.54 0.65 8.02 1.63 15.09 6.21 19.90 12.92 0.39 0.55 0.27 1.31-0.28 1.70-0.21 0.15-0.46 0.23-0.71 0.23"
                            />
                            <path
                                id="Fill-34"
                                fill="#F9685D"
                                d="m32.43 108.61c-0.40 0-0.80-0.2-1.03-0.56-3.27-5.18-5.00-11.17-5.02-17.33-0.01-5.21 1.23-10.39 3.59-14.99 0.31-0.60 1.04-0.83 1.64-0.52 0.60 0.31 0.83 1.04 0.52 1.64-2.21 4.31-3.33 8.98-3.32 13.86 0.01 5.70 1.62 11.23 4.64 16.02 0.36 0.57 0.19 1.32-0.38 1.68-0.20 0.13-0.43 0.19-0.65 0.19"
                            />
                            <path
                                id="Fill-36"
                                fill="#F9685D"
                                d="m58.19 49.80c-0.22 0-0.44-0.06-0.64-0.18-0.57-0.36-0.74-1.11-0.39-1.68 3.23-5.20 7.85-9.37 13.37-12.05 4.67-2.27 9.86-3.40 15.01-3.26 0.67 0.02 1.2 0.58 1.18 1.25-0.02 0.67-0.57 1.18-1.25 1.19-4.83-0.13-9.50 0.88-13.88 3.01-5.11 2.48-9.38 6.34-12.37 11.15-0.23 0.37-0.63 0.57-1.03 0.57"
                            />
                            <path
                                id="Fill-38"
                                fill="#BE2612"
                                d="m120.95 59.35c0 2.89-2.33 5.24-5.21 5.25s-5.22-2.33-5.23-5.22 2.32-5.24 5.2-5.25c2.89-0.01 5.23 2.33 5.24 5.22"
                            />
                            <path
                                id="Fill-40"
                                fill="#BE2612"
                                d="m157.82 59.26c0 2.89-2.33 5.24-5.21 5.25-2.88 0.01-5.22-2.33-5.23-5.22s2.32-5.24 5.21-5.25c2.88-0.01 5.22 2.33 5.23 5.22"
                            />
                            <path
                                id="Fill-42"
                                fill="#10ADCD"
                                d="m16.46 106.68c-0.39 0-0.77-0.14-1.08-0.42-0.68-0.6-0.74-1.64-0.14-2.32l90.28-102.01c0.6-0.68 1.64-0.74 2.31-0.14 0.68 0.60 0.74 1.64 0.14 2.32l-90.28 102.01c-0.32 0.37-0.77 0.56-1.22 0.56"
                            />
                            <path
                                id="Fill-44"
                                fill="#12C3DB"
                                d="m1.64 82.42c-0.54 0-1.07-0.27-1.38-0.75-0.49-0.76-0.27-1.78 0.49-2.27l109.9-71.00c0.76-0.49 1.78-0.27 2.26 0.49 0.49 0.76 0.27 1.78-0.49 2.27l-109.9 71c-0.27 0.18-0.58 0.26-0.88 0.26"
                            />
                            <path
                                id="Fill-46"
                                fill="#10ADCD"
                                d="m161.98 100.3c-0.06 0-0.12 0-0.18-0.01l-160.34-17.88c-0.90-0.1-1.55-0.91-1.45-1.81 0.10-0.90 0.90-1.55 1.81-1.45l160.34 17.88c0.9 0.1 1.54 0.91 1.44 1.81-0.09 0.84-0.8 1.46-1.62 1.46"
                            />
                            <path
                                id="Fill-48"
                                fill="#12C3DB"
                                d="m173.51 87.34c-0.12 0-0.24-0.01-0.36-0.04l-156.1-34.23c-0.89-0.19-1.45-1.07-1.25-1.96s1.07-1.44 1.95-1.25l156.11 34.23c0.89 0.19 1.45 1.07 1.25 1.96-0.16 0.77-0.84 1.29-1.59 1.29"
                            />
                            <path
                                id="Fill-50"
                                fill="#12C3DB"
                                d="m106.74 118.78c-0.49 0-0.97-0.21-1.3-0.63l-71.28-91.71c-0.56-0.71-0.43-1.75 0.28-2.30s1.74-0.43 2.30 0.28l71.28 91.71c0.56 0.71 0.43 1.75-0.28 2.3-0.3 0.24-0.65 0.35-1 0.35"
                            />
                            <path
                                id="Fill-52"
                                fill="#12C3DB"
                                d="m44.76 123.63c-0.06 0-0.11-0.01-0.17-0.01-0.90-0.09-1.55-0.9-1.46-1.8l10.58-106.01c0.09-0.90 0.89-1.57 1.79-1.47 0.90 0.09 1.56 0.90 1.47 1.80l-10.58 106.01c-0.09 0.84-0.80 1.48-1.63 1.48"
                            />
                            <path
                                id="Fill-54"
                                fill="#12C3DB"
                                d="m69.39 121.78c-0.42 0-0.83-0.16-1.15-0.47-0.64-0.64-0.65-1.68-0.01-2.33l82.80-83.99c0.64-0.64 1.67-0.65 2.32-0.01 0.64 0.64 0.64 1.68 0.01 2.32l-82.80 83.98c-0.32 0.33-0.74 0.49-1.16 0.49"
                            />
                        </g>
                        <g id="Group-140" transform="translate(106 46)">
                            <path
                                id="Fill-136"
                                fill="#F9685D"
                                d="m1.70 8.32c-0.62 0-1.16-0.45-1.24-1.07-0.09-0.67 0.40-1.29 1.08-1.37l46.38-5.75c0.68-0.08 1.31 0.39 1.40 1.06 0.09 0.67-0.40 1.29-1.08 1.37l-46.38 5.75c-0.05 0.01-0.11 0.01-0.16 0.01"
                            />
                            <path
                                id="Fill-138"
                                fill="#BE2612"
                                d="m23.75 26.93c-0.06 0-0.12-0.01-0.19-0.01-0.68-0.10-1.14-0.72-1.04-1.38 0.35-2.27 1.91-4.19 4.08-5.03 2.16-0.83 4.64-0.47 6.47 0.96 0.54 0.42 0.62 1.18 0.20 1.71-0.42 0.53-1.20 0.61-1.74 0.20-1.14-0.89-2.68-1.12-4.03-0.60-1.35 0.52-2.32 1.72-2.54 3.13-0.09 0.60-0.62 1.03-1.22 1.03"
                            />
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
